import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, forwardRef } from 'react';
import classnames from 'classnames'; // $FlowFixMe: untyped import

import TextareaAutosize from 'react-textarea-autosize';
import { Text } from "../../Typography";
import Icon from '../../Common/Icon';
import styles from './Input.scss';

var Input = function Input(_ref, ref) {
  var _classnames, _classnames2;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      label = _ref.label,
      className = _ref.className,
      classNameField = _ref.classNameField,
      errorMessage = _ref.errorMessage,
      maxLength = _ref.maxLength,
      iconName = _ref.iconName,
      onClickIcon = _ref.onClickIcon,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 1 : _ref$rows,
      _ref$showFocusLine = _ref.showFocusLine,
      showFocusLine = _ref$showFocusLine === void 0 ? true : _ref$showFocusLine,
      isReadonly = _ref.isReadonly,
      isDisabled = _ref.isDisabled,
      isAutosizable = _ref.isAutosizable,
      isCompact = _ref.isCompact,
      onBlur = _ref.onBlur,
      props = _objectWithoutProperties(_ref, ["type", "label", "className", "classNameField", "errorMessage", "maxLength", "iconName", "onClickIcon", "rows", "showFocusLine", "isReadonly", "isDisabled", "isAutosizable", "isCompact", "onBlur"]);

  var value = props.value;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setFocused = _useState2[1];

  var handleFocus = function handleFocus() {
    return setFocused(true);
  };

  var handleBlur = function handleBlur(e) {
    if (onBlur) {
      onBlur(e);
    }

    setFocused(false);
  };

  var isLabelScaled = value || isFocused;

  var fieldProps = _objectSpread({}, props, {
    rows: rows,
    type: type === 'textarea' ? '' : type,
    readOnly: isReadonly,
    disabled: isDisabled,
    onFocus: handleFocus,
    onBlur: handleBlur,
    className: classnames(styles.input, classNameField, (_classnames = {}, _defineProperty(_classnames, styles.isCompact, isCompact), _defineProperty(_classnames, styles.withIcon, iconName), _defineProperty(_classnames, styles.textarea, type === 'textarea'), _defineProperty(_classnames, styles.textarea_isCompact, type === 'textarea' && isCompact), _defineProperty(_classnames, styles.textarea_withIcon, type === 'textarea' && iconName), _classnames))
  });

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.inputWrap, (_classnames2 = {}, _defineProperty(_classnames2, styles.isFocused, isFocused), _defineProperty(_classnames2, styles.hasError, !!errorMessage), _defineProperty(_classnames2, styles.showFocusLine, showFocusLine), _classnames2))
  }, type === 'textarea' ? /*#__PURE__*/React.createElement(TextareaAutosize, Object.assign({}, fieldProps, {
    inputRef: ref || undefined,
    useCacheForDOMMeasurements: true,
    maxLength: maxLength
  })) : /*#__PURE__*/React.createElement("input", Object.assign({}, fieldProps, {
    ref: ref,
    maxLength: maxLength
  })), label && !isCompact && /*#__PURE__*/React.createElement("label", {
    htmlFor: fieldProps.id,
    className: classnames(styles.label, _defineProperty({}, styles.isScaled, isLabelScaled))
  }, label), iconName && onClickIcon && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles.iconBtn,
    onClick: onClickIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    color: value && value.length > 0 ? 'accent' : 'icon'
  })), iconName && !onClickIcon && /*#__PURE__*/React.createElement("div", {
    className: styles.iconWrap
  }, /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    color: "icon"
  }))), !!errorMessage && /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "fail"
  }, errorMessage));
};

export default forwardRef(Input);